<script lang="ts">
  /* Interne Download-Seite für die KF Fernwartung (10.10.2026).

     Das Passwort ist ausdrücklich KEIN Schutz: Es steht im Bündel, die Dateien
     liegen unter einem Zufallspfad, und wer ihn kennt, kommt auch ohne die
     Seite dran. Es soll nur verhindern, dass jemand versehentlich hier landet
     und die Fernwartung installiert. Deshalb bewusst einfach gehalten. */
  const PASSWORT = 'fernwartung';
  const BASIS = '/downloads/fw-9bd46ad1c7fa9daf3a4e8812';

  let eingabe = $state('');
  let freigeschaltet = $state(false);
  let fehler = $state(false);

  try {
    freigeschaltet = sessionStorage.getItem('kf-dl') === '1';
  } catch {
    /* Ohne Sitzungsspeicher muss das Passwort eben jedes Mal eingegeben werden. */
  }

  function pruefe(ereignis: SubmitEvent): void {
    ereignis.preventDefault();
    if (eingabe.trim().toLowerCase() === PASSWORT) {
      freigeschaltet = true;
      fehler = false;
      try {
        sessionStorage.setItem('kf-dl', '1');
      } catch {
        /* siehe oben */
      }
    } else {
      fehler = true;
    }
  }

  $effect(() => {
    const vorher = document.title;
    document.title = 'Downloads — IT-Service Karsten Fischer';
    const meta = document.createElement('meta');
    meta.name = 'robots';
    meta.content = 'noindex, nofollow, noarchive';
    document.head.appendChild(meta);
    return () => {
      document.title = vorher;
      meta.remove();
    };
  });
</script>

<div class="rechtstext">
  <h1>Downloads</h1>

  {#if !freigeschaltet}
    <p>Dieser Bereich ist für Kunden gedacht, die von mir eine Anleitung bekommen haben.</p>
    <form onsubmit={pruefe}>
      <p>
        <label for="dl-passwort">Passwort</label><br />
        <input
          id="dl-passwort"
          type="password"
          bind:value={eingabe}
          autocomplete="off"
          autocapitalize="off"
        />
        <button class="tb-btn-primary" type="submit">Weiter</button>
      </p>
      {#if fehler}
        <p role="alert">Das Passwort stimmt nicht.</p>
      {/if}
    </form>
  {:else}
    <h2>KF Fernwartung</h2>
    <p>
      Läuft still im Hintergrund, damit ich Ihren Rechner nach Absprache warten kann. Jede
      Sitzung wird auf Ihrem PC mitgeschrieben, und Sie können sie jederzeit pausieren.
    </p>

    <h2>Windows</h2>
    <p><a class="tb-btn-primary" href="{BASIS}/KF-Fernwartung.exe">KF-Fernwartung.exe laden</a></p>
    <p class="stand">
      Edge oder Windows zeigen bei neuen Programmen eine Warnung („Der Download wird nicht
      häufig heruntergeladen“). Das ist normal: unter „…“ → „Beibehalten“ den Download
      behalten, dann die Datei starten.
    </p>

    <h2>Linux</h2>
    <p>
      <a class="tb-btn-primary" href="{BASIS}/kf-fernwartung-linux-amd64">Linux PC / Server</a>
      &nbsp;
      <a class="tb-btn-sekundaer" href="{BASIS}/kf-fernwartung-linux-arm64">Raspberry Pi (arm64)</a>
    </p>
    <p class="stand">Im Terminal einrichten:</p>
    <pre>cd ~/Downloads
chmod +x kf-fernwartung-linux-amd64
sudo ./kf-fernwartung-linux-amd64</pre>

    <p class="stand">
      Beim ersten Start fragt das Programm nach PC-Name, Standort und Kundennummer und zeigt
      die Bedingungen zur Zustimmung. Freigeschaltet wird der PC erst nach meiner Prüfung.
    </p>
  {/if}
</div>

<style>
  input {
    font: inherit;
    padding: 0.5rem 0.7rem;
    border: 1px solid var(--tb-text-600);
    border-radius: 0.5rem;
    margin-right: 0.5rem;
  }

  pre {
    background: var(--tb-navy-900);
    color: #e8f0fa;
    padding: 0.8rem 1rem;
    border-radius: 0.5rem;
    overflow-x: auto;
    font-size: 0.9rem;
  }
</style>
